<template>
    <div class="app-container">
        <div class="question-container" :class="isCollapse?'collapse':''">
            <pang-title :text="$router.lang.get('客服  中心')" eng="Customer Service"/>
            <div class="tab-container">
                <pang-tab
                :tabs="tabs" v-model:current="currentTab"/>
                <div class="question-butt">
                    <pang-butt @click="goNew" :text="$router.lang.get('詢問')"/>
                </div>
            </div>
            <div v-if="questions.length > 0" class="list-container">
                <div v-for ="question in questions" :key="question.id" class="question">
                    <div>{{ QUESTION_TYPE_CHOICES[question.question_type] }}</div>
                    <div :title="question.article.title" @click="goDetail(question)">{{ question.article.title }}</div>
                    <div :class="question.answer_id?'handled':'unhandled'">{{ $router.lang.get(question.answer_id?'已處理':'待處理') }}</div>
                    <div>{{ question.create_at.slice(0, 10) }}</div>
                </div>
            </div>
            <div class="no-data" v-else>
                {{ $router.lang.get('暫無數據') }}
            </div>
            <pang-pager v-if="totalPages > 1" @change="goto" :totalPages="totalPages" :currentPage="currentPage"/>
        </div>
    </div>
</template>

<script>

import { useScreenState } from '../../store';
import enums from '../../utils/enums'
import { PangTitle, PangTab, PangPager, PangButt } from '../../components'
import request from '../../api/request'
import message from '../../utils/message'
import browser from '../../utils/browser';

const links = [
    '/customerservice/faq',
    '/customerservice/question',
    '/customerservice/terms',
]

export default {
    name: 'Question',
    components: {
        PangTitle,
        PangTab,
        PangPager,
        PangButt,
    },
    data () {
        return {
            screenState: useScreenState(),
            currentTab: 1,
            totalPages: 1,
            currentPage: 1,
            tabs: [
                'FAQ',
                this.$router.lang.get('1:1詢問'),
                this.$router.lang.get('會員條款'),
            ],
            QUESTION_TYPE_CHOICES: enums.QUESTION_TYPE_CHOICES,
            questions: [
            ],
        };
    },
    computed: {
        isCollapse() {
            return this.screenState.screenWidth < 900;
        },
    },
    methods: {
        goto (page) {
            this.currentPage = page
            this.getQuestions() 
        },
        goDetail (question) {
            let url = '/customerservice/question/' + question.id
            if (browser.isPc)
                window.open(url)
            else
                this.$router.push(url)
        },
        goNew () {
            this.$router.push('/customerservice/question/new')
        },
        getParams () {
            let params = {
                limit: 10,
                page: this.currentPage,
                article__author: this.screenState.user.id,
            }
            return params
        },
        getQuestions () {
            let params = this.getParams()
            let _this = this
            request.get('/questions' , params, _this).then(function (res) {
                if (res.status == 200) {
                    _this.questions = res.data.results
                    _this.totalPages = res.data.paging.total_pages
                    _this.currentPage = res.data.paging.page
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
    },
    watch: {
        currentTab (val) {
            this.$router.push(links[val])
        },
    },
  beforeMount () {
    if (!this.screenState.user) {
        this.$router.replace({ path: '/account/login', query: {returnurl: this.$route.fullPath}});
    }
  },
    mounted () {
        if (this.screenState.user)
            this.getQuestions() 
    },
}
</script>

<style scoped>

.question-container {
    max-width: 1040px;
    width: 90vw;
    margin: 0 auto;
    margin-bottom: 100px;
}

.question-butt {
    margin-left: auto;
    margin-top: 10px;
}

.tab-container {
    display: flex;
}

.question {
    font-size: 18px;
    color: #67696D;
    display: flex;
    line-height: 29px;
    margin-bottom: 30px;
}

.list-container {
    margin: 49px 0;
}

.question > div:first-child{
    width: 100px;
    height: 29px;
    background: linear-gradient(132deg, #C5A76C 0%, #E0CCA4 100%);
    border-radius: 14px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    margin-right: 49px;
}

.question > div:nth-child(2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    width: calc(100% - 149px - 240px);
}

.question > div:last-child, .handled {
    font-size: 16px;
    color: #A7ADB1;
}

.question > div:last-child {
    margin-left: 84px;
}

.handled, .unhandled {
    margin-left: 10px;
}

.unhandled {
    color: #C5A76C;
}

.no-data {
    font-size: 40px;
    text-align: center;
    margin-top: 150px;
    color: #A8AEB3;
}

.collapse .question {
    line-height: calc(1.6vw + 15.6px);
    font-size: calc(1vw + 9px);
}


.collapse .question > div:last-child{
    margin-left: calc(14.33vw - 45px);
}

.collapse .question > div:nth-child(2) {
    width: calc(100% - 149px - 240px + 84px - 14.33vw + 45px + 49px - 8.44vw + 27px);
    min-width: 40px;
}

.collapse .question > div:first-child {
    width: calc(5vw + 55px);
    height: calc(1.6vw + 15.6px);
    border-radius: calc(0.8vw + 7.8px);
    line-height: calc(1.6vw + 15.6px);
    margin-right: calc(5vw + 4px);
    font-size: calc(1vw + 5px);
}

</style>
